import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import OurFleet from './components/OurFleet';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && (location.state as { scrollToFleet?: boolean }).scrollToFleet) {
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById('fleet');
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: 'smooth' });
        } else if (attempts < 10) {
          setTimeout(() => tryScroll(attempts + 1), 100);
        }
      };
      setTimeout(() => tryScroll(), 200);
    }
  }, [location.state]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <OurFleet />
        <ContactSection />
        <TrustSection />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}